export class CardEvents
{
    static SCALE_CHANGED: string = 'CardEvents.SCALE_CHANGED';
    static ON_HAND_TAKE_VIRTUAL_CARDS: string = 'CardEvents.ON_HAND_TAKE_CARD';
    static ON_HAND_RETURN_VIRTUAL_CARDS: string = 'CardEvents.ON_HAND_RETURN_VIRTUAL_CARD';
    static ON_CARD_RIGHT_UP: string = 'CardEvents.ON_CARD_RIGHT_UP';
    static ON_CARD_POINTER_DOWN: string= 'CardEvents.ON_CARD_POINTER_DOWN';
}
